export class SmeltingProductInfo {
    constructor({
          id= null,
          planCode= ``,
          day= ``,
          locName= ``,
          shift='',
          furnaceName= ``,
          furnaceBatch= ``,
          productName= ``,
          electricCost= ``,
          basicElectricCost= ``,
          productMass= ``,
          basicProductMass= ``,
          CrPercent= ``,
          // operationRate= ``,
          // recycleRate= ``,
          mineralConsumeRate= ``,
          ballConsumeRate= ``,
          earthConsumeRate= ``,
          coalConsumeRate= ``,
          stoneConsumeRate= ``,
          materialPercent= ``,

      } = {}) {
      this.id = id;
      this.planCode = planCode;
      this.day = day;
      this.locName = locName;
      this.shift = shift;
      this.furnaceName = furnaceName;
      this.furnaceBatch = furnaceBatch;
      this.productName = productName;
      this.electricCost = electricCost;
      this.basicElectricCost = basicElectricCost;
      this.productMass = productMass;
      this.basicProductMass = basicProductMass;
      this.CrPercent = CrPercent;
      // this.operationRate = operationRate;
      // this.recycleRate = recycleRate;
      this.mineralConsumeRate = mineralConsumeRate;
      this.ballConsumeRate = ballConsumeRate;
      this.earthConsumeRate = earthConsumeRate;
      this.coalConsumeRate = coalConsumeRate;
      this.stoneConsumeRate = stoneConsumeRate;
      this.materialPercent = materialPercent;
    }
  }
  export function gridFields() {
    return Object.freeze([
        {
          key: 'planCode',
          label: 'lbl.basic.planCode',
          sortable: true,
          form: {
            type: 'input'
          }
        },
        {
          key: 'locName',
          label: 'lbl.basic.locName',
          sortable: true,
          form: {
            type: 'input'
          }
        },
        {
          key: 'day',
          label: 'lbl.basic.day',
          sortable: true,
          form: {
            type: 'datepicker'
          }
        },
        {
          key: 'shift',
          label: 'lbl.basic.shift',
          sortable: true,
          form: {
            type: 'input'
          }
        },
        // {
        //   key: 'furnaceName',
        //   label: 'lbl.basic.furnaceName',
        //   sortable: true,
        //   form: {
        //     type: 'select',
        //     options: [
        //       {value:"default", text:"lbl.basic.select.one"},
        //       {value:"1", text:"opt.furnaceNumber1"},
        //       {value:"2", text:"opt.furnaceNumber2"},
        //       {value:"3", text:"opt.furnaceNumber3"},
        //       {value:"4", text:"opt.furnaceNumber4"},
        //       {value:"5", text:"opt.furnaceNumber5"},
        //       {value:"6", text:"opt.furnaceNumber6"},
        //     ]
        //   }
        // },
        // {
        //   key: 'furnaceBatch',
        //   label: 'lbl.basic.furnaceBatch',
        //   sortable: true,
        //   form: {
        //     type: 'input'
        //   }
        // },

        {
          key: 'productName',
          label: 'lbl.prd.execution.productionName',
          sortable: false,
          form: {
            type: 'input'
          }
        },
        {
          key: 'electricCost',
          label: 'lbl.prd.execution.electricCost',
          sortable: false,
          form: {
            type: 'input'
          }
        },
        {
          key: 'basicElectricCost',
          label: 'lbl.prd.execution.basicElectricCost',
          sortable: false,
          form: {
            type: 'input'
          }
        },
        {
          key: 'productMass',
          label: 'lbl.prd.execution.productMass',
          sortable: false,
          form: {
            type: 'input'
          }
        },
        {
          key: 'basicProductMass',
          label: 'lbl.prd.execution.basicProductMass',
          sortable: false,
          form: {
            type: 'input'
          }
        },
        {
          key: 'CrPercent',
          label: 'Cr%',
          sortable: false,
          form: {
            type: 'input'
          }
        },
        // {
        //   key: 'operationRate',
        //   label: 'lbl.prd.execution.operationRate',
        //   sortable: false,
        //   form: {
        //     type: 'input'
        //   }
        // },
        // {
        //   key: 'recycleRate',
        //   label: 'lbl.prd.execution.recycleRate',
        //   sortable: false,
        //   form: {
        //     type: 'input'
        //   }
        // },
        // {
        //   key: 'mineralConsumeRate',
        //   label: 'lbl.prd.execution.mineralConsumeRate',
        //   sortable: false,
        //   form: {
        //     type: 'input'
        //   }
        // },
        // {
        //   key: 'ballConsumeRate',
        //   label: 'lbl.prd.execution.ballConsumeRate',
        //   sortable: false,
        //   form: {
        //     type: 'input'
        //   }
        // },
        // {
        //   key: 'earthConsumeRate',
        //   label: 'lbl.prd.execution.earthConsumeRate',
        //   sortable: false,
        //   form: {
        //     type: 'input'
        //   }
        // },
        // {
        //   key: 'coalConsumeRate',
        //   label: 'lbl.prd.execution.coalConsumeRate',
        //   sortable: false,
        //   form: {
        //     type: 'input'
        //   }
        // },
        // {
        //   key: 'stoneConsumeRate',
        //   label: 'lbl.prd.execution.stoneConsumeRate',
        //   sortable: false,
        //   form: {
        //     type: 'input'
        //   }
        // },
        // {
        //   key: 'materialPercent',
        //   label: 'lbl.prd.execution.materialPercent',
        //   sortable: false,
        //   form: {
        //     type: 'input'
        //   }
        // }
    ]);
  }
  export const fields = Object.freeze(Object.keys(new SmeltingProductInfo()).map(i => 'entity.' + i));
  export const filterFields = [
    'filter.planCodeFilter',
    'filter.plantFilter',
    'filter.shiftFilter',
    'filter.startDayFilter',
    'filter.endDayFilter',
    'filter.furnaceName',
  ];
  export const filter = {
    'planCodeFilter': "",
    'plantFilter': "",
    'shiftFilter': "",
    'startDayFilter': "",
    'endDayFilter': "",
    'furnaceNameFilter': "",
  };
